import type { PublicAppConfig } from '@protoss/shared';

/**
 * Pre-authentication configuration store.
 *
 * Populated during the bootstrap fetch of /api/auth/firebase-client-config
 * (see main.tsx) before React mounts. Provides workspace config values
 * that must be available on unauthenticated pages (sign-in, set-password, etc.)
 * without waiting for the Firebase auth state to resolve.
 */

let _allowedMethods: string[] = ['password'];
let _brandConfig: Partial<PublicAppConfig> = {};
let _workspaceSlug: string | null = null;

export function setPreAuthConfig(cfg: {
  allowedMethods?: string[];
  workspaceSlug?: string;
  productName?: string;
  brandConfig?: Partial<PublicAppConfig>;
}): void {
  _allowedMethods = cfg.allowedMethods ?? ['password'];
  _workspaceSlug = cfg.workspaceSlug ?? null;
  _brandConfig = cfg.brandConfig ?? (cfg.productName ? { productName: cfg.productName } : {});
}

export function getPreAuthConfig(): {
  allowedMethods: string[];
  workspaceSlug: string | null;
  brandConfig: Partial<PublicAppConfig>;
} {
  return {
    allowedMethods: _allowedMethods,
    workspaceSlug: _workspaceSlug,
    brandConfig: _brandConfig,
  };
}
